import { IconPencilPin } from "@tabler/icons-react";

function StartPointModeToolAction({ onClick }) {
  return (
    <button
      type="button"
      className="app-icon-btn app-icon-btn--update start-point-tool-mode-action"
      aria-label="Add driving driving tour points"
      title="Add driving driving tour points"
      onClick={onClick}
    >
      <IconPencilPin size={14} />
    </button>
  );
}

export default StartPointModeToolAction;
